import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/layout/HomePageLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PortfolioViewTracker"] */ "/opt/build/repo/src/components/public/PortfolioViewTracker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ShareButton"] */ "/opt/build/repo/src/components/ui/ShareButton.tsx");
